<template>
  <div class="Right_box">
    <div class="RightContent" v-if="dataInfo">
      <div class="tit">{{ dataInfo.productName }}</div>
      <div class="download">
        <div class="record">
          <div>{{ $t("DataInfo.CreateDate") }}</div>
          <div class="small_txt">{{ dataInfo.createTime }}</div>
        </div>

        <div class="record">
          <div>{{ $t("DataInfo.fileNmu") }}</div>

          <div class="big_txt" v-if="dataListTable">
            {{ dataListTable.tableData.total }}
          </div>
        </div>
        <div class="record">
          <div>{{ $t("DataInfo.seeNum") }}</div>
          <div class="big_txt">{{ dataInfo.visits }}</div>
        </div>
        <div class="record">
          <div>{{ $t("DataInfo.download") }}</div>
          <div class="big_txt">{{ dataInfo.downloads }}</div>
        </div>
      </div>
      <!-- <div class="download_box" @click="download()">
        <div class="download_box_tit">{{ $t("DataInfo.downloadBtn") }}</div>
      </div> -->
      <!-- <div class="other_fun">
        <div class="other_fun_box">
          <i class="iconfont icon-shoucang3"></i>
          <div class="other_fun_box_txt">收藏</div>
        </div>
        <div class="other_fun_box">
          <i class="iconfont icon-fenxiang1"></i>
          <div class="other_fun_box_txt">分享</div>
        </div>
      </div> -->
    </div>
    <!-- 2 -->
  
    <div class="other_data">
      <div class="tit">
        <div class="tit_box">{{ $t("DataInfo.otherData") }}</div>
      </div>
      <div
        class="data_img"
        v-for="(item, index) in seenDataList.slice(0, 2)"
        :key="index"
        @click="toOther(item.dataId)"
      >
        <div class="data_img_box">
          <img :src="`${GLOBAL.imageUrl}${item.image}`" alt />
        </div>
        <div class="txt">{{ item.productName }}</div>
      </div>
    </div>
      <el-dialog
      title="登录提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="login_tip">
        <i class="iconfont icon-xuanzhong1"></i>
        <div class="tip">请先登录</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="toLogin()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import bus from "@/bus";
import { seenData } from "@/axios/datashare.js";
import { mapMixin } from "@/util/mixin";
export default {
  mixins: [mapMixin],
  data() {
    return {
      dialogVisible: false,
      dataId: null,
      seenDataList: [],
    };
  },
  mounted() {
    this.dataId = this.$route.query.dataId;
    this.getSeenData(this.dataId);
  },
  methods: {
    // 校验是否登录
    verifyLogin() {
      return localStorage.getItem("token") && localStorage.getItem("loginName");
    },
     toLogin() {
      this.dialogVisible = false;
      var query = this.$route.fullPath;
      this.$router.push(`/login?redirect=${query}`);
    },
    download() {
      var userVerifyLogin = this.verifyLogin();
      if (!userVerifyLogin) {
        // 提示用户登录
        this.dialogVisible = true;
        return;
      }
      const a = document.createElement("a"); // 创建a标签
      a.setAttribute("download", ""); // download属性
      a.setAttribute(
        "href",
        `${this.GLOBAL.url}sdg-api/share/data/batch/download?productCode=${this.dataId}&productName=${this.dataInfo.productName}`
      ); // href链接
      // productCode=${scope.row.product_code}
      a.click(); // 自执行点击事件
    },
    async getSeenData(dataId) {
      var res = await seenData(dataId);
      this.seenDataList = res.data.data;
      console.log(res);
    },
    toOther(val) {
      this.$router.push(`/datainfo?dataId=${val}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.Right_box {
  margin-left: 20px;
  max-width: 300px;
}
    .login_tip {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      i {
        font-size: 40px;
        color: rgba(248, 187, 134, 1);
        font-weight: 600;
        margin-bottom: 10px;
      }
      .tip {
        font-weight: 600;
        font-size: 22px;
      }
    }
.RightContent {
  background: #fff;
  border-radius: 6px;
  padding: 10px 20px;
  .tit {
    width: 264px;
    // height: 50px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    color: #000000;
    line-height: 25px;
    font-weight: 600;
  }
  .download {
    display: flex;
    flex-direction: column;
    .record {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      //   padding: 13px 0;
      height: 50px;
      border-bottom: 1px solid #d8d8d8;

      .small_txt {
        color: #666;
        font-size: 14px;
      }
      .big_txt {
        font-weight: 600;
        color: #666;
        font-size: 24px;
      }
    }
  }
  .download_box {
    margin-top: 32px;
    // width: 280px;
    height: 40px;
    background: #4165eb;
    box-shadow: 0px 4px 4px 0px rgba(65, 101, 235, 0.21);
    border-radius: 6px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
      transition: 0.2s;
    }
    // cursor:not-allowed;
    .download_box_tit {
      // width: 28px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 20px;
    }
  }
  .other_fun {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 40px;
    .other_fun_box {
      display: flex;
      align-items: center;
      .other_fun_box_txt {
        font-size: 14px;
        color: #000;
        margin-left: 10px;
      }
      .icon-shoucang3 {
        color: #db1868;
        font-size: 20px;
      }
      .icon-fenxiang1 {
        color: #f06a2d;
        font-size: 20px;
      }
    }
  }
}
.other_data {
  margin-top: 20px;
  background: #fff;

  .tit {
    width: 100%;
    height: 45px;
    background: #3f7e44;
    border-radius: 6px 6px 0px 0px;
    .tit_box {
      //   width: 264px;
      padding-left: 20px;
      //   height: 25px;

      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 45px;
    }
  }
  .data_img {
    padding: 20px;
    margin-top: 10px;
    cursor: pointer;
    &:hover img {
      transform: scale(1.1);
      transition: 0.2s;
      opacity: 0.7;
    }
    .data_img_box {
      width: 100%;
      height: 158px;
      overflow: hidden;
      img {
        transition: 0.2s;
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }

    .txt {
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 20px;
    }
  }
}
</style>